var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.product-groups")))]),
      _c(
        "w-card-content",
        [
          !_vm.useSimpleGroups
            ? _c("app-product-group-select-autocomplete", {
                attrs: { value: _vm.value, "use-id": "" },
                on: {
                  input: function ($event) {
                    return _vm.onInput($event)
                  },
                },
              })
            : _c("app-product-group-select-autocomplete-simple", {
                attrs: {
                  "main-group": _vm.product.SimpleMainGroup,
                  "sub-group": _vm.product.SimpleSubGroup,
                },
                on: {
                  "update:mainGroup": function ($event) {
                    return _vm.$set(_vm.product, "SimpleMainGroup", $event)
                  },
                  "update:main-group": function ($event) {
                    return _vm.$set(_vm.product, "SimpleMainGroup", $event)
                  },
                  "update:subGroup": function ($event) {
                    return _vm.$set(_vm.product, "SimpleSubGroup", $event)
                  },
                  "update:sub-group": function ($event) {
                    return _vm.$set(_vm.product, "SimpleSubGroup", $event)
                  },
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }